import { gql } from '@apollo/client';

export const DELETE_SERVICE_PROVIDER = gql`
  mutation deleteServiceProvider($id: ID!) {
    deleteServiceProvider(id: $id) {
      id
    }
  }
`;
